import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ShipperService } from '../../../services/shipper.service';
import { MasterService } from '../../../services/master.service';
import { OrderService } from '../../../services/order.service';
import { AppService } from '../../../services/app.service';
import { Shipper } from '../../../models/shipper.model';
import { OrderCustoms } from '../../../models/order.model';

@Component({
    selector: 'app-order-customs-form',
    templateUrl: './order-customs-form.component.html',
    styleUrls: ['./order-customs-form.component.scss']
})
export class OrderCustomsFormComponent implements OnInit {
    @Output() closeDialogue = new EventEmitter();

translations: any;
orderCustoms: OrderCustoms = new OrderCustoms();
shipperPostalCodeDetails: any = {City:"", Country:"", Region:""};
customerPostalCodeDetails: any = {City:"", Country:"", Region:""};
articlesLoaded: boolean = false;

formGroup: FormGroup;
formGroupErrors: any;

constructor( @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, public orderService: OrderService, public shipperService: ShipperService, public masterService: MasterService, public appService: AppService, public dialog: MatDialog, public dialogRef: MatDialogRef<OrderCustomsFormComponent>){ 
    this.data.shipper = new Shipper();
    this.formGroupErrors = {
        HantracoGrossWeight :{},
        ArticleGrossWeight : {},
        NumberOfPackages : {}
    };

    this.formGroup = this.formBuilder.group({
        HantracoGrossWeight :['',[Validators.required, Validators.pattern]],
        ArticleGrossWeight : ['',[Validators.required, Validators.pattern]],
        NumberOfPackages : ['',[Validators.required, Validators.pattern]]
    });
}

ngOnInit() {
    this.setPageTranslations();
    this.getShipperData();
    this.getOrderCustoms();
}

setOrderCustomHeader(){
    this.orderCustoms.OrderId = this.data.Id;
    this.orderCustoms.TotalInvoiceValue = this.data.P_TotalAmount;
    this.orderCustoms.TotalInvoiceValue = Number(this.orderCustoms.TotalInvoiceValue);
    this.orderCustoms.VectorCustomValue = (((Number(this.orderCustoms.TotalInvoiceValue)/108)*100) - 65);
    if(this.orderCustoms.HantracoGrossWeight != 0){
        this.orderCustoms.Factor = Number(this.orderCustoms.VectorCustomValue) / Number(this.orderCustoms.HantracoGrossWeight);
    }
}

setPageTranslations(){
    this.translations = JSON.parse(sessionStorage.getItem('pageData')); 
}

getOrderCustoms(){
    this.appService.showLoading();
    this.orderService.orderCustomSelect(this.data.Id).subscribe(
        res => this.orderCustomSelectSuccess(res),
        error => this.apiFaillure(error)
    );
}

orderCustomSelectSuccess(res){
    if (res.Status == 1 && res.Data != 'null') {
        var data = JSON.parse(res.Data).Table;
        if(data.length == 0)
            this.orderCustoms = new OrderCustoms();
        else
            this.orderCustoms = JSON.parse(res.Data).Table[0];
        this.getOrderCustomsArticles();
        this.setOrderCustomHeader();
    }
    else if (res.Status == -1) {
        this.apiFaillure(res.Message);
    }
}

getOrderCustomsArticles(){
    this.orderService.orderCustomArticles(this.orderCustoms.Id.toString()).subscribe(
        res => this.orderCustomArticlesSuccess(res),
        error => this.apiFaillure(error)
    );
}

orderCustomArticlesSuccess(res){
    this.appService.hideLoading();
    if (res.Status == 1) {	
        this.orderCustoms.Articles = JSON.parse(res.Data).Table;
        this.articlesLoaded = true;
    }
    else if (res.Status == -1) {
        this.apiFaillure(res.Message);
    }
}

getShipperData(){
    this.appService.showLoading();
    this.shipperService.select(this.data.ShipperId).subscribe(
        res => this.selectShipperSuccess(res),
        error => this.apiFaillure(error)
    );
}

selectShipperSuccess(res){
    this.appService.hideLoading();
    if (res.Status == 1) {
        this.data.shipper = JSON.parse(res.Data)[0];
        this.getShipperPostalCodeDetails(); 

    }
    // else if (res.Status == -1) {
    //   this.apiFaillure(res.Message);
    // }
}

getShipperPostalCodeDetails(){
    this.appService.showLoading();
    if(this.data.shipper.PostalCodeId != null){
        this.masterService.cccDetail(this.data.shipper.PostalCodeId).subscribe(
            res => this.selectShipperPostalCodeDetailsSuccess(res),
            error => this.apiFaillure(error)
        );
    }    
}

selectShipperPostalCodeDetailsSuccess(res){
    this.appService.hideLoading();
    if (res.Status == 1) {
        this.shipperPostalCodeDetails = JSON.parse(res.Data)[0]; 
        this.getCustomerPostalCodeDetails();
    }
    else if (res.Status == -1) {
        this.apiFaillure(res.Message);
    }
}

getCustomerPostalCodeDetails(){
    this.appService.showLoading();
    if(this.data.C_PostalCodeId != null){
        this.masterService.cccDetail(this.data.C_PostalCodeId).subscribe(
            res => this.selectCustomerPostalCodeDetailsSuccess(res),
            error => this.apiFaillure(error)
        );
    }  
}

selectCustomerPostalCodeDetailsSuccess(res){
    this.appService.hideLoading();
    if (res.Status == 1) {
        this.customerPostalCodeDetails = JSON.parse(res.Data)[0]; 
    }
    else if (res.Status == -1) {
        this.apiFaillure(res.Message);
    }
}

apiFaillure(error): void {
    this.appService.showDialogue(this.translations.msgFailureHeader, this.translations[error]);
}

hantracoGrossWeightChanged(e){
    if(e != '' && e != '0'){
        this.orderCustoms.Factor = Number(this.orderCustoms.VectorCustomValue) / Number(e);
        this.setArticleCustomsValues();
        this.orderCustoms.SumArticleCustomsValue = Number(this.getSumArticleCustomsValue());
    }
    else
        this.orderCustoms.Factor = 0;
}

setArticleCustomsValues(){
    for(var i = 0; i < this.orderCustoms.Articles.length; i++){
        this.orderCustoms.Articles[i].ArticleCustomValue = (Number(this.orderCustoms.Articles[i].ArticleGrossWeight) * Number(this.orderCustoms.Factor));
    }
}

articleGrossWeightChanged(e, index){
    var grossPercentage = this.orderCustoms.Articles[index].GrossPerNetPercentage.toString().substr(0, this.orderCustoms.Articles[index].GrossPerNetPercentage.toString().indexOf('%'))
    this.orderCustoms.Articles[index].ArticleNetWeight = (Number(e) * Number(grossPercentage)/100 );
    this.orderCustoms.Articles[index].ArticleCustomValue = (Number(e) * Number(this.orderCustoms.Factor));
    this.orderCustoms.SumArticleGrossWeight = 0;
    this.orderCustoms.SumArticleGrossWeight = Number(this.getSumArticleGrossWeight(e));
    this.orderCustoms.SumArticleNetWeight = Number(this.getSumArticleNetWeight());
    this.orderCustoms.SumArticleCustomsValue = Number(this.getSumArticleCustomsValue());
}

getSumArticleGrossWeight(currentArticleGrossWeight: string){
    var total = Number('0');
    for(var i = 0; i < this.orderCustoms.Articles.length; i++){
        total += Number(this.orderCustoms.Articles[i].ArticleGrossWeight);
    }
    return total;
}

getSumArticleNetWeight(){
    var total = Number('0');
    for(var i = 0; i < this.orderCustoms.Articles.length; i++){
        total += Number(this.orderCustoms.Articles[i].ArticleNetWeight);
    }
    return total;
}

getSumArticleCustomsValue(){
    var total = Number('0');
    for(var i = 0; i < this.orderCustoms.Articles.length; i++){
        total += Number(this.orderCustoms.Articles[i].ArticleCustomValue);
    }
    return total;
}

numberOfPackagesChanged(e, index){
    this.orderCustoms.SumNumberOfPackages = 0;
    this.orderCustoms.SumNumberOfPackages = Number(this.getSumNumberOfPackages(e));
}

getSumNumberOfPackages(currentNumberOfPackages: string){
    var total = Number('0');
    for(var i = 0; i < this.orderCustoms.Articles.length; i++){
        total += Number(this.orderCustoms.Articles[i].NumberOfPackages);
    }
    return total;
}

save(){
    this.appService.showLoading();
    this.orderService.orderCustomSave(this.orderCustoms).subscribe(
        res => this.orderCustomsSaveSuccess(res),
        error => this.apiFaillure(error)
    );
}

orderCustomsSaveSuccess(res){
    if (res.Status == 1) {
        this.appService.showDialogue(this.translations.hdSuccess, this.translations[res.Message])
            .afterClosed().subscribe(result => {
            if (result) {
                this.close();
            }          
        });  
    }
    else if (res.Status == -1) {
        this.apiFaillure(res.Message);
    }
}

keypressEventHandler(e){
    return e.keyCode == 32 ? false : true
}

close(){
    this.dialogRef.close();
}

getDecimal(param){
    var result = param != undefined ? param : 0;
    return parseFloat(result).toFixed().toString(); 
}
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/order-customs-form/order-customs-form.component.ts